<template>
  <div class="body vezne" v-if="Veznedar">
    <div class="detay">
      <hr class="m-0">
      <div class="icerik" style="height: calc(100vh + 50px) !important;">
        <Yukleniyor :data="lo"></Yukleniyor>
        <PanelBand class="PanelBand"></PanelBand>
        <el-row :gutter="24">
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Kalan Bakiye', sayi: this.Toplam.Kasa+'<sup>TL</sup>', icon: 'el-icon-circle-plus-outline', renk: 'ins1'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Toplam Kar', sayi: this.Toplam.Kar+'<sup>TL</sup>', icon: 'el-icon-circle-plus-outline', renk: 'ins2'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Bugün Tahsilat', sayi: this.Toplam.BugunKasa+'<sup>TL</sup>', icon: 'el-icon-circle-plus-outline', renk: 'ins3'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Bugün Kar', sayi: this.Toplam.BugunKar+'<sup>TL</sup>', icon: 'el-icon-circle-plus-outline', renk: 'ins4'}"></mWidget>
          </el-col>
          <el-col :span="19">
            <div class="Veznedar mt-3" v-if="Veznedar.lKasa==0">
              <el-alert
                title="Bakiye Tükendi"
                type="error"
                description="Tahsilat alabileceğiniz bakiye kalmamıştır."
                :closable="false">
              </el-alert>
            </div>
            <div class="Veznedar mt-3" v-if="Veznedar.lKasa>0">
              <div class="SpotlightKutu">
                <div class="input">
                  <el-input
                    :disabled="lo"
                    placeholder="Arama Yapın"
                    v-model="Kelime"
                    @keyup.enter.native="Getir">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <a @click="Kapat">
                    <i v-if="Kelime && !lo" class="el-icon-close"></i>
                    <i v-if="lo" class="el-icon-loading"></i>
                  </a>
                </div>
                <div v-if="Kelime.length>3" class="aramasonuc">
                  <div style="padding: .25rem 0.75rem;margin: 0" v-if="!Sorgu" class="alert alert-secondary"
                       role="alert">
                    <small><b>{{Kelime}}</b> Arama Sonuçları için Enter tuşuna basınız</small>
                  </div>
                  <div style="padding: .25rem 0.75rem;margin: 0" v-if="Sonuc && Sorgu" class="alert alert-success"
                       role="alert">
                    <small><b>{{ArananKelime}}</b> Kelimesine ait borçlu listesi.</small>
                  </div>
                  <div style="padding: .25rem 0.75rem;margin: 0" v-if="!Sonuc && Sorgu" class="alert alert-danger"
                       role="alert">
                    <small><b>{{ArananKelime}}</b> Kelimesine ait sonuç bulunamadı.</small>
                  </div>
                  <ul>
                    <li v-for="k in Kisi" v-if="k.Tutar>0" @click="Uygula(k.Kisi_id)">
                      <div class="aramasonucbilgi">
                        <h2>{{k.AdSoyadText}}</h2>
                        <h3>{{k.Bina}} {{k.Kat}}.Kat {{k.kNo}} No</h3>
                      </div>
                      <div class="aramasonuctutar">
                        <div class="aramaodenecek">{{k.Tutar}}</div>
                        <div v-if="k.Zam" class="aramazam"><sup>ZAM</sup> {{k.Zam}}</div>
                        <div v-if="k.Icra" class="aramazam"><sup>İCRA</sup> {{k.IcraOdenecek}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sayfahead  mb-3">
                <h1>{{SayfaAdi}}</h1>
                <el-button-group class="float-right">
                  <el-button v-if="Kisi_id"
                             class="el-button YeniBtn el-button--danger el-button--small" @click="Kisi_id=null">Kapat
                  </el-button>
                </el-button-group>
              </div>
              <VezneKisiTahsilat :Veznedar="Veznedar" @SayfaAdi="SayfaAdiGetir($event)" @Yenile="SayfaYukle()" :Kisi_id="Kisi_id"  v-if="Kisi_id"></VezneKisiTahsilat>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="Gecmis mt-3 BlokSabit scrollkaydir" style="height: 50vh">
              <div class="BlokSabitKutu">
                <table class="table table-xs table-hover">
                  <thead>
                  <tr>
                    <th colspan="4" class="text-center">İŞLEM GEÇMİŞİ</th>
                  </tr>
                  <tr>
                    <th>Saat</th>
                    <th>Makbuz No</th>
                    <th class="text-right">Tutar</th>
                    <th class="text-right">Kar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="g in Gecmis">
                    <td>{{g.Saat}}</td>
                    <td>{{g.mNo}}</td>
                    <td class="text-right">{{g.Tutar}}<sup>TL</sup></td>
                    <td class="text-right">{{g.Kar}}<sup>TL</sup></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import PanelBand from "../../components/Pack/Panel/PanelBand";
  import mWidget from "../../components/Pack/Genel/mWidget";
  import Yukleniyor from "../../components/Doc/Yukleniyor";
  import VezneKisiTahsilat from "../../components/Pack/Vezne/VezneKisiTahsilat";

  export default {

    components: {VezneKisiTahsilat, Yukleniyor, mWidget, PanelBand},
    data() {
      return {
        SayfaAdi: "Veznedar Ekranı",
        lo: false,
        Sonuc: false,
        Kelime: '',
        Kisi: null,
        Kisi_id: null,
        Veznedar: null,
        ArananKelime: null,
        Gecmis: null,
        Sayi: 0,
        Sorgu: null,
        Toplam: {
          Limit: 0,
          Tahsilat: 0,
          Virman: 0,
          Kasa: 0,
          BugunKasa: 0,
          BugunKar: 0,
          Kar: 0,
        }
      }
    },
    methods: {
      SayfaAdiGetir(event) {
        // console.log(event)
        this.SayfaAdi = event;
      },
      Getir() {
        this.lo = true;
        //$("body").addClass("bodyarama");
        this.$store.dispatch("Post", {
          Kelime: this.Kelime,
          path: 'spesiyal/spotlight'
        })
          .then(response => {
            this.ArananKelime = response.Kelime;
            this.Kisi = response.Kisi;
            this.Sonuc = response.Sonuc;
            this.Sayi = response.Say;
            this.lo = false;
            this.Sorgu = true;

          })
      },
      Uygula(Kisi_id) {
        this.Kisi_id = Kisi_id;
        this.Kapat();
      },
      Kapat() {
        this.lo = false;
        this.SayfaAdi = "Veznedar Ekranı";
        this.Sonuc = false;
        this.Kelime = '';
        this.Kisi = null;
        this.Cari = null;
        this.ArananKelime = null;
        this.Sayi = 0;
        this.Sorgu = null;
        //$("body").removeClass("bodyarama");
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {
          Kelime: this.Kelime,
          path: 'spesiyal/veznedar'
        })
          .then(response => {
            this.Veznedar = response.TahsilatMerkezi;
            this.Toplam = response.Toplam;
            this.Gecmis = response.Gecmis;
            this.lo = false;
          })
      }
    },
    created() {
      this.SayfaYukle();
    }

  }
</script>

<style scoped>
  .body .icerik {
    height: 100vh !important;
  }

  .SpotlightKutu {
    z-index: 2;
  }


  .body.vezne {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Panel/Veznedar.vue